import { registerPropertyManagerSection } from '@/core';
import AssembleReferenceAxisPropertySection from '@/components/editor/property-manager/assemble-reference/AssembleReferenceAxisPropertySection.vue';

registerPropertyManagerSection({
  id: 'assembly-reference-axis',
  title: '装配体基准轴',
  order: 35,
  component: AssembleReferenceAxisPropertySection,
  actions: {
    confirm: true,
    cancel: true,
  },
  isApplicable: (context) =>
    context.activeCommand === 'assembly-reference-axis'
    || Boolean(context.assemblyReferenceAxisActive),
  onConfirm: (context) => {
    context.submitAssemblyReferenceAxis?.();
  },
  onCancel: (context) => {
    context.cancelAssemblyReferenceAxis?.();
  },
});
